/* ============================================================================
   AIRES · LIFETUNE ONE — BUY 2 GET 1 FREE LANDING PAGE

   >>> THIS CONFIG BLOCK IS THE SINGLE SOURCE OF TRUTH FOR PRICING. <<<
   Every price shown on the page — tier cards, per-unit maths, savings,
   summary, both CTAs and the sticky bar — is rendered from TIERS below.
   The numbers hard-coded in the template are only pre-JS placeholders and
   are overwritten on load, so they can never drift out of sync with the
   cart. Change a price here and the whole page follows.
   ========================================================================== */
const CONFIG = {

  /* 1. OFFER COUNTDOWN — 60 minutes from page load.
        NOTE: this resets if the visitor refreshes. To hold a real 60 minutes
        per visitor, persist the deadline on first load:
            let end = localStorage.getItem('aires_offer_end');
            if (!end) { end = Date.now() + CONFIG.COUNTDOWN_MINUTES*60000;
                        localStorage.setItem('aires_offer_end', end); }
        Set SHOW_COUNTDOWN:false to hide the timer entirely. */
  COUNTDOWN_MINUTES: 60,
  SHOW_COUNTDOWN: true,

  /* 2. CART URLS — product "Lifetune One Exclusive" (gid 8398878769410).
        Purpose-built BOGO variants: the variant NAME matches the offer, so
        there is no fulfilled-quantity ambiguity.
          44435199230210  "Lifetune One Single Pack"  $99.99   -> 1 device
          44435208306946  "Buy 2 Get 1 Free"          $199.98  -> 3 devices
          44435199262978  "Buy 3 Get 2 Free"          $299.97  -> 5 devices
        The product also carries a "Buy 4 Get 3 Free" variant. It is
        deliberately NOT used here — three tiers is the ladder, and a fourth
        option adds decision friction. */
  CART: {
    1: "/cart/44435199230210:1",
    2: "/cart/44435208306946:1",
    3: "/cart/44435199262978:1"
  },

  /* 3. PRICING. units = what the customer receives. price MUST equal the
        variant price above, or the cart total will contradict the page. */
  TIERS: {
    1: { units:1, price:99.99,  retail:99.99  },
    2: { units:3, price:199.98, retail:299.97 },
    3: { units:5, price:299.97, retail:499.95 }
  },

  UNIT_PRICE: 99.99,
  FREE_SHIP_MIN: 199,   // free shipping threshold, in dollars
  DEFAULT_TIER: 2
};

/* ---------- helpers ---------- */
const $  = s => document.querySelector(s);
const $$ = s => [...document.querySelectorAll(s)];
const money = n => "$" + n.toFixed(2).replace(/\.00$/, "");
const money2 = n => "$" + n.toFixed(2);

document.getElementById("yr").textContent = new Date().getFullYear();

/* ============================================================
   PAINT TIER CARDS FROM CONFIG
   Runs once, before anything else, so the cards can never show a
   price that disagrees with the variant the CTA links to.
   ============================================================ */
(function paintTierCards(){
  $$(".tier").forEach(el => {
    const t = CONFIG.TIERS[+el.dataset.tier];
    if (!t) return;
    const saved = t.retail - t.price;

    const px = el.querySelector(".tier-price");
    if (px) px.innerHTML = "<b>" + money2(t.price) + "</b>" +
                           (saved > 0 ? "<s>" + money2(t.retail) + "</s>" : "");

    const per = el.querySelector(".per");
    if (per && saved > 0){
      per.innerHTML = "<em>Works out to</em> " + money2(t.price / t.units) + " each";
    }

    const sv = el.querySelector(".save");
    if (sv && saved > 0) sv.textContent = "You save " + money2(saved);

    const flag = el.querySelector(".tier-flag:not(.alt)");
    if (flag && saved > 0){
      flag.textContent = "Best value · Save " + Math.round((1 - t.price / t.retail) * 100) + "%";
    }
  });

  // closing CTA headline
  const finalPx = $('.sec.dark h2 span[style*="gold-lt"]');
  if (finalPx) finalPx.textContent = money(CONFIG.TIERS[CONFIG.DEFAULT_TIER].price);
})();

/* ============================================================
   BUNDLE SELECTOR
   ============================================================ */
let selected = CONFIG.DEFAULT_TIER;

function renderTier(){
  const t = CONFIG.TIERS[selected];
  const free = t.units - Math.round(t.price / CONFIG.UNIT_PRICE);
  const saved = t.retail - t.price;

  $$(".tier").forEach(el => el.classList.toggle("on", +el.dataset.tier === selected));

  $("#sumQty").textContent    = t.units + (t.units === 1 ? " device" : " devices");
  $("#sumRetail").textContent = money2(t.retail);
   $("#sumTotal").textContent  = money2(t.price);

  const freeShip = t.price >= CONFIG.FREE_SHIP_MIN;
  const ship = $("#sumShip");
  if (ship){
    ship.textContent = freeShip ? "FREE" : "Calculated at checkout";
    ship.className   = freeShip ? "free-txt" : "";
  }
  const sub = $("#ctaSub");
  if (sub) sub.textContent = (freeShip ? "Ships free" : "Ships") + " in 1–2 business days · 30-day money-back guarantee";

  const freeRow = $("#sumFree").parentElement;
  if (saved > 0){
    freeRow.style.display = "flex";
    $("#sumFree").textContent = free + (free === 1 ? " free device" : " free devices");
    $("#sumDisc").textContent = "−" + money2(saved);
  } else {
    freeRow.style.display = "none";
  }

  const label = "Add to Cart — " + money2(t.price);
  $$("[data-cta]").forEach(a => {
    a.href = CONFIG.CART[selected] || "#";
    if (a.id === "ctaMain"){
      a.innerHTML = label + ' <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
    }
  });

  $("#stickyPrice").textContent = money(t.price);
  $("#stickyQty").textContent   = t.units + (t.units === 1 ? " device" : " devices");

  const hb = $("[data-px-bundle]"), he = $("[data-px-each]");
  if (hb) hb.textContent = money(t.price);
  if (he) he.textContent = money2(t.price / t.units);
}

$$(".tier").forEach(el => {
  el.addEventListener("click", e => {
    e.preventDefault();
    selected = +el.dataset.tier;
    renderTier();
  });
});
renderTier();

/* ============================================================
   COUNTDOWN — 60 minutes from page load
   ============================================================ */
(function(){
  const box = $(".deadline");
  if (!CONFIG.SHOW_COUNTDOWN){ if (box) box.style.display = "none"; return; }
  const end = Date.now() + CONFIG.COUNTDOWN_MINUTES * 60000;
  const pad = n => String(n).padStart(2, "0");

  function tick(){
    const d = end - Date.now();
    if (d <= 0){
      box.innerHTML = '<span class="lbl" style="color:#fff">This offer has expired</span>';
      return;
    }
    $("#cm").textContent = pad(Math.floor(d / 6e4));
    $("#cs").textContent = pad(Math.floor(d / 1e3) % 60);
    setTimeout(tick, 1000);
  }
  tick();
})();

/* ============================================================
   EEG BEFORE / AFTER COMPARISON SLIDER
   ============================================================ */
(function(){
  const box = $("#compare");
  if (!box) return;
  const chip = $("#stateChip");
  let split = 50, dragging = false;

  // PUBLISHED VALUES ONLY — Sysoev & Rybina 2025, Stage 3 HRV table.
  //   Phone only        : LF/HF 1.2 | LF 43.4 | HF 38.2
  //   Phone + Lifetune  : LF/HF 0.8 | LF 33.4 | HF 40.2
  // Do not substitute invented figures here. These are the numbers the
  // study reports and the only ones this page is able to defend.
  const LO = { ratio: 1.2, lf: 43.4, hf: 38.2 };  // without Aires
  const HI = { ratio: 0.8, lf: 33.4, hf: 40.2 };  // with Aires

  function paint(){
    box.style.setProperty("--split", split + "%");
    // t = share of the frame showing WITH AIRES (left side of the wipe).
    const t = split / 100;
    const mix = (a, b) => a + (b - a) * t;

    $("#roBeta").textContent  = mix(LO.ratio, HI.ratio).toFixed(1);
    $("#roAlpha").textContent = mix(LO.lf, HI.lf).toFixed(1);
    $("#roBal").textContent   = mix(LO.hf, HI.hf).toFixed(1);

    const good = t > 0.5;
    $("#roBeta").style.color  = good ? "#4FDCA9" : "#FF8C79";
    $("#roAlpha").style.color = good ? "#4FDCA9" : "#FF8C79";
    $("#roBal").style.color   = good ? "#4FDCA9" : "#FF8C79";

    chip.textContent = good ? "With Aires" : "Without Aires";
    chip.className   = "scan-state " + (good ? "state-on" : "state-off");
  }

  function setFromX(clientX){
    const r = box.getBoundingClientRect();
    split = Math.max(2, Math.min(98, ((clientX - r.left) / r.width) * 100));
    paint();
  }

  const start = e => { dragging = true; box.classList.add("touched");
                       setFromX(e.touches ? e.touches[0].clientX : e.clientX); };
  const move  = e => { if (!dragging) return;
                       setFromX(e.touches ? e.touches[0].clientX : e.clientX);
                       if (e.cancelable) e.preventDefault(); };
  const end   = () => dragging = false;

  box.addEventListener("mousedown", start);
  box.addEventListener("touchstart", start, {passive:true});
  window.addEventListener("mousemove", move);
  window.addEventListener("touchmove", move, {passive:false});
  window.addEventListener("mouseup", end);
  window.addEventListener("touchend", end);
  box.addEventListener("click", e => { if (!dragging) setFromX(e.clientX); });

  paint();

  /* Auto-demo once on first view: sweeps out to both extremes and RETURNS TO
     CENTRE, so the resting state is always a 50/50 split. */
  let played = false;
  new IntersectionObserver((entries, obs) => {
    entries.forEach(en => {
      if (!en.isIntersecting || played) return;
      played = true;
      const t0 = performance.now();
      (function sweep(now){
        const p = Math.min(1, (now - t0) / 3200);
        split = 50 + 30 * Math.sin(p * Math.PI * 2);
        paint();
        if (p < 1 && !dragging) requestAnimationFrame(sweep);
        else if (!dragging) { split = 50; paint(); }
      })(t0);
      obs.disconnect();
    });
  }, {threshold:.55}).observe(box);
})();

/* ============================================================
   STICKY BUY BAR — appears after the hero CTA scrolls away
   ============================================================ */
(function(){
  const bar = $("#sticky"), trigger = $(".hero-cta");
  if (!bar || !trigger) return;
  new IntersectionObserver(([e]) => {
    bar.classList.toggle("show", !e.isIntersecting && e.boundingClientRect.top < 0);
  }, {threshold:0}).observe(trigger);
})();
